import * as React from 'react';
import { Icon } from '../../icon';
import { type Tag } from '../../tags';
import { type ListDescription } from './ListDescription';
import type { ListItemLeftContentProps } from './ListItem';
import { ListItem } from './ListItem';

export type ListNavigationProps = {
  readonly text: string;
  readonly descriptions?: React.ReactElement<typeof ListDescription> | React.ReactElement<typeof ListDescription>[];
  readonly onPress?: () => void;
  readonly tag?: React.ReactElement<typeof Tag>;
  readonly loading?: boolean;
  readonly disabled?: boolean;
  readonly LeftContent?: ListItemLeftContentProps;
  /**
   * Use for testing-library identification purposes, only if you can't rely on user-readable text or a11y labels.
   */
  readonly testID?: string;
};

export const ListNavigation = ({
  text,
  descriptions,
  onPress,
  tag,
  loading,
  disabled,
  LeftContent,
  testID,
}: ListNavigationProps) => {
  return (
    <ListItem
      title={text}
      loading={loading}
      disabled={disabled}
      descriptions={descriptions}
      onPress={onPress}
      RightContent={<Icon name="chevronright-small" />}
      tags={tag}
      LeftContent={LeftContent}
      testID={testID}
    />
  );
};
